import {MessageCircleDashed as MessageCircle, Clock, Mic, Globe, Smartphone, Sparkles} from 'lucide-react'

const features = [
  { icon: MessageCircle, text: "Conversação real pelo WhatsApp", color: "#6CC4C4" },
  { icon: Clock, text: "Disponível 24h por dia, 7 dias por semana", color: "#B038B2" },
  { icon: Mic, text: "Prática de pronúncia e fala desde o primeiro dia", color: "#E05A8D" },
  { icon: Globe, text: "Aprende seu ritmo e adapta as lições", color: "#6CC4C4" },
  { icon: Smartphone, text: "Direto do seu celular, onde você estiver", color: "#F5C542" },
  { icon: Sparkles, text: "+500 horas de conteúdo autoral", color: "#B038B2" },
]

const ecosystemItems = [
  "Lives semanais com professores reais",
  "Comunidade ativa",
  "App próprio iOS e Android",
  "Método GO4D alinhado ao CEFR",
  "Certificação TOEFL iBT",
]

export default function LucyIASection() {
  return (
    <section id="lucy-ia" className="relative overflow-hidden">
      {/* Bloco 1 — Lucy IA */}
      <div className="bg-[#0c0e2b] py-20 px-5">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight mb-4">
              LUCY <span className="text-green-400">IA</span>
            </h2>
            <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
              A primeira tutora de inglês <strong className="text-white">AI-First</strong> do Brasil integrada a um ecossistema completo de fluência.
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left — Text + Features */}
            <div>
              <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white leading-tight mb-6" style={{ fontFamily: "'DM Serif Display', serif" }}>
                Aprenda praticando<br />
                conversação de verdade
              </h3>

              <p className="text-gray-300 text-base md:text-lg mb-3 leading-relaxed">
                Com a Lucy, você aprende praticando <strong className="text-white">conversação de verdade</strong> com sua professora particular, direto do seu celular pelo{" "}
                <span className="text-green-400 font-semibold">WhatsApp</span>.
              </p>

              <p className="text-gray-400 text-base mb-8 leading-relaxed">
                E não estudando gramática isolada ou repetindo frases feitas como em cursos e métodos de escolas de inglês tradicionais.
              </p>

              {/* Feature Cards Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {features.map((feat, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-4 py-3.5 hover:bg-white/10 transition-colors duration-300"
                  >
                    <div
                      className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                      style={{ backgroundColor: `${feat.color}20` }}
                    >
                      <feat.icon size={18} style={{ color: feat.color }} />
                    </div>
                    <span className="text-sm text-gray-200 font-medium leading-snug">{feat.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — Lucy Image */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md">
                <div className="absolute inset-0 bg-gradient-to-br from-[#B038B2]/20 to-[#0E8EA0]/20 rounded-3xl blur-3xl" />
                <img
                  src="https://static.lumi.new/32/3264c3881a333011cbdec359de997974.webp"
                  alt="Lucy IA - Tutora virtual de inglês"
                  className="relative w-full rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bloco 2 — Lucy é o cérebro. EW Pass é o corpo. */}
      <div className="bg-[#111338] py-16 px-5">
        <div className="max-w-5xl mx-auto text-center">
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 leading-tight" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Lucy é o cérebro.{" "}
            <span className="text-green-400">EW Pass é o corpo.</span>
          </h3>

          <p className="text-gray-400 text-lg mb-8">
            O ecossistema completo que potencializa a Lucy:
          </p>

          {/* Ecosystem Tags */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {ecosystemItems.map((item, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-5 py-2.5 text-sm text-gray-200 font-medium hover:bg-white/10 transition-colors duration-300"
              >
                <span className="w-2 h-2 rounded-full bg-[#B038B2]" />
                {item}
              </span>
            ))}
          </div>

          <p className="text-2xl md:text-3xl font-black text-white italic" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Tudo alimenta a inteligência da Lucy.
          </p>
        </div>
      </div>
    </section>
  )
}
